import type { Example } from '../types';

export const markdownCalloutsExample: Example = {
  id: 'markdown-callouts',
  title: 'Markdown in Parameters',
  categoryId: 'parameters',
  description: 'Rich text, headings, and callout blocks in the params panel',
  scadCode: `/* Markdown in Parameters */

// markdown:tip
// **Markdown in Parameters** — You can embed rich text anywhere in the
// parameters panel using \`// markdown:*\` comments. Try the callout types
// below: **tip**, **note**, **warning**, **idea**, and **error**.

// ## Callout Types

// markdown:note
// A **note** block is for neutral information or context. Use it to explain
// what a parameter does or link to relevant documentation.

// Radius
radius = 30; // [5:1:60]

// markdown:warning {radius > 50}
// Large radius values may produce **very high polygon counts** — consider
// lowering **$fn** if the model is slow to compile.

// markdown:idea
// Try linking snapshots from markdown using \`[Load preset](snapshot:Name)\`
// once you have snapshots defined in your model.

// markdown:error {radius < 10}
// Radius is too small — the geometry may not render correctly below 10 mm.

// ## Appearance

// Height
height = 20; // [5:1:50]

// Segments
$fn = 64; // [16, 32, 64, 128]

// Color
// color
color_val = [0.45, 0.3, 0.75];

// --- parameters end ---

color(color_val)
difference() {
  sphere(r=radius);
  translate([0, 0, -radius])
    cylinder(r=radius * 0.4, h=radius * 2, center=false, $fn=$fn);
  translate([0, 0, radius - height])
    cube([radius * 3, radius * 3, radius * 2], center=true);
}
`,
};
